import {captureSentryExceptionAndThrowLocal} from 'app/services/sentry/sentryLogging';

export default function isInvalidViewData(data: any, index: number): boolean {
  if (!data[index]) {
    captureSentryExceptionAndThrowLocal(new Error(`Missing data for view-index ${index}`), {
      extra: {index, data},
    });
    return true;
  }
  return false;
}
